import { render, staticRenderFns } from "./SubPackageList.vue?vue&type=template&id=2dcb8cb1&scoped=true&"
import script from "./SubPackageList.vue?vue&type=script&lang=js&"
export * from "./SubPackageList.vue?vue&type=script&lang=js&"
import style0 from "./SubPackageList.vue?vue&type=style&index=0&id=2dcb8cb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb8cb1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VImg})
